import React__default from 'react';
import { Box, Menu } from '@mui/material';
import { withSuspense } from '../../../withSuspense/index.js';

var BasketActionsLayout = function (_a) {
    var moreAnchorEl = _a.moreAnchorEl, isMenuOpen = _a.isMenuOpen, handleMenuClose = _a.handleMenuClose, primaryActions = _a.primaryActions, secondaryActions = _a.secondaryActions;
    var menuId = "menu-basket-actions";
    return (React__default.createElement(Box, { className: "BasketActions", sx: {
            display: "flex"
        } },
        primaryActions,
        React__default.createElement(Menu, { "data-testid": "menuActionBasket", anchorEl: moreAnchorEl, anchorOrigin: { vertical: "bottom", horizontal: "right" }, id: menuId, transformOrigin: { vertical: "top", horizontal: "right" }, open: isMenuOpen, onClose: handleMenuClose }, secondaryActions)));
};
var index = withSuspense(BasketActionsLayout);

export { index as default };
//# sourceMappingURL=index.js.map
